export const SIZE_NORMAL = 'normal';
export const SIZE_TINY = 'tiny';
export const SIZE_TINIEST = 'tiniest';
export const SIZE_SMALL = 'small';
export const SIZE_MEDIUM = 'medium';
export const SIZE_LARGE = 'large';
